import Vue from 'vue';

import result from './result.vue';
Vue.component('mag-result', result);